<template>
  <div>
    <ul class="page-tabs" v-if="userId">
      <li v-for="tab in pageTabs" :key="tab.id" :class="{ active: tab.id === activeTab }" @click="activeTab = tab.id">
        {{ tab.name }}
      </li>
    </ul>
    <div class="build" v-if="activeTab === 1">
      <div class="tabs" v-if="bannerData.type === 0 && bannerData.elementInfo.remainPart === 2">
        <span
          v-for="item of tabs"
          :key="item.id"
          :class="['item', { on: isActiveBannerType(item.id) }]"
          @click="switchType(item.id)"
          >{{ item.name }}</span
        >
      </div>
      <div class="show-banner">
        <Banner
          :style="`transform: scale(${scale});transform-origin: 0 0;`"
          :bannerName="bannerData.sizeName"
          :size="bannerData.size"
          :bannerTextValue="bannerData.textValue"
          :bgConfig="bannerData.bgParameter"
          :elementImg="bannerData.elementImg"
          :textInfo="bannerData.textInfo"
          :textStyle="bannerData.textStyle"
          :elConfig="bannerData.elementInfo"
        />
        <portrait
          style="position: absolute; bottom: 0; right: 0"
          v-if="isPortraitMaterialType(bannerData.elementTypeId)"
          :selectedId="bannerData.elementId"
          :portraitMap="portraitMap"
          @getPortraits="getPortraits"
          @selectPortrait="selectPortrait"
        ></portrait>
      </div>
      <Banner
        class="real-banner"
        id="banner"
        :bannerName="bannerData.sizeName"
        :size="bannerData.size"
        :bannerTextValue="bannerData.textValue"
        :bgConfig="bannerData.bgParameter"
        :elementImg="bannerData.elementImg"
        :textStyle="bannerData.textStyle"
        :textInfo="bannerData.textInfo"
        :elConfig="bannerData.elementInfo"
      />
      <theme
        :themes="themes"
        :currentTagId="bannerData.tagId"
        @updateMaterials="updateMaterials"
        @regainMaterials="regainMaterials"
      ></theme>
      <text-input
        :textStyles="bannerData.textStyle"
        :bgParameter="bannerData.bgParameter"
        :bannerTextValue="bannerData.textValue"
        :isAllTextLegal="isAllTextLegal"
        @changeLabelStyle="changeLabelStyle"
        @textChange="onTextChange"
        @checkTextLegal="checkTextLegal"
      >
        <el-button slot="tool" type="primary" round @click="onGenerate" :disabled="!isAllTextLegal"
          >生成并上传</el-button
        >
      </text-input>
      <RightNav
        :backgrounds="bannerBackgrounds"
        :elements="bannerElements"
        :textStyles="bannerTextStyles"
        :onDrawData="bannerData"
        @updateBackground="selectBackground"
        @updateElement="selectElement"
        @switchElement="
          material => {
            switchType(2, material);
          }
        "
        @updateTextStyle="selectTextStyle"
      />
      <!-- <div class="msg">学科网banner生成平台</div> -->
      <span class="loading" v-show="isUploading"
        ><span class="text"><i class="el-icon-loading"></i> 正在上传</span></span
      >
    </div>
    <BannerDesigns
      v-if="activeTab === 2"
      :designData="designData"
      :sizeId="bannerSizeId"
      :userId="userId"
      @toDesign="toDesign"
      @getPosters="getPosters"
      @toDesignDetail="toDesignDetail"
    />
  </div>
</template>
<script>
import BannerDesigns from "@/pages/myDesign/components/banner-designs.vue";
import { freshItemOfArr, genMaterialData, isPortraitMaterialType, randomItemExcept } from "@/assets/scripts/common";
import {
  getBackgrounds,
  getElements,
  getPortraits,
  getSizeInfo,
  getTagColor,
  getTextStylesBySizeId,
  htmlToCanvas,
} from "@/assets/scripts/features";
import portrait from "@/components/portrait.vue";
import RightNav from "@/components/RightNav.vue";
import theme from "@/components/theme.vue";
import Banner from "@/pages/banner/components/banner.vue";
import textInput from "@/pages/banner/components/textInput.vue";
import { tabs } from "@/pages/banner/js/banner-static";
import { mapMutations, mapState } from "vuex";
import { genSizeAndTextInfo, onUpload } from "./specific-feature";
import { getDesignDetail, saveBannerToBase, getBannerList } from "@/pages/banner/js/banner-feature";
export default {
  name: "specific-page",
  data() {
    return {
      pageTabs: [
        {
          name: "制作图片",
          id: 1,
        },
        { name: "我的设计", id: 2 },
      ],
      activeTab: 1,
      userId: "",
      schemeId: "",
      tabs,
      bgPageIndex: 0,
      elementPageIndex: 0,
      themes: [],
      scale: 1,
      // 用户头像列表数据
      portraitMap: {},
      isUploading: false,
      isAllTextLegal: false,
      uploadUrl: "https://shopcenter.xkw.com/info/shop/premote",
      designData: {
        list: [],
        totalPage: 0,
      },
      bannerSizeId: "",
    };
  },
  components: {
    textInput,
    RightNav,
    theme,
    Banner,
    portrait,
    BannerDesigns,
  },
  computed: {
    ...mapState("banner", ["bannerData", "bannerBackgrounds", "bannerElements", "bannerTextStyles"]),
  },
  created() {
    this.init();
  },
  async mounted() {
    this.clearCacheInfo();
    const uploadUrl = this.$route.query.uploadUrl;
    if (uploadUrl) {
      this.uploadUrl = uploadUrl;
    }
    this.userId = this.$route.query.userId;
  },
  methods: {
    ...mapMutations("banner", [
      "setBannerMaterials",
      "setBannerTextStyles",
      "clearCacheInfo",
      "updateBannerData",
      "structBannerDataList",
    ]),
    async init() {
      this.bannerSizeId = this.$route.query.id || 88;
      this.themes = await getTagColor();
      const defaultTag = this.themes[0];
      Promise.all([
        getBackgrounds(defaultTag.id, 1),
        getElements(defaultTag.id, 1),
        getSizeInfo(this.bannerSizeId),
        getTextStylesBySizeId(this.bannerSizeId),
        getPortraits(),
      ]).then(([bgs, eles, bannerInfo, textStyles, portraitMap]) => {
        this.setBannerTextStyles(textStyles);
        this.setBannerMaterials({
          backgrounds: bgs,
          elements: eles,
        });
        const background = freshItemOfArr(bgs);
        const element = freshItemOfArr(eles);
        const data = {
          tagId: defaultTag.id,
          ...genMaterialData(element, background),
          ...genSizeAndTextInfo(
            bannerInfo,
            this.bannerTextStyles[0].styles,
            this.bannerTextStyles[0].materialTextStyleId
          ),
        };
        this.portraitMap = portraitMap;
        this.scale = bannerInfo.width > 800 ? 800 / bannerInfo.width : 1;
        this.updateBannerData(data);
      });
    },
    async getPosters(params) {
      this.designData = await getBannerList(params);
    },
    async onGenerate() {
      if (!this.isAllTextLegal) return;
      this.isUploading = true;
      let dom = document.querySelector("#banner");
      const bannerBase64Data = await htmlToCanvas(dom, 2);
      if (this.userId) {
        saveBannerToBase([this.bannerData], this.schemeId, this.userId);
      }
      await onUpload(bannerBase64Data, this.uploadUrl);
      this.isUploading = false;
    },
    // 输入文字改变
    onTextChange(texts) {
      this.updateBannerData({ textValue: texts });
    },
    // 检查文字是否合法
    checkTextLegal(isLegal) {
      if (isLegal === this.isAllTextLegal) return;
      this.isAllTextLegal = isLegal;
    },
    // 选中背景图片
    selectBackground(material) {
      const data = genMaterialData(null, material);
      this.updateBannerData(data);
    },
    // 选中元素图片
    selectElement(material) {
      const data = genMaterialData(material);
      this.updateBannerData(data);
    },
    // 选中文字行数
    selectTextStyle(fontInfo) {
      const styles = [];
      for (let x = 0; x < fontInfo.styles.length; x++) {
        const s = fontInfo.styles[x];
        styles[x] = {
          ...s,
          i: x,
          labelStyle: "样式1",
          showLabelStyle: false,
        };
      }
      this.updateBannerData({
        textStyleId: fontInfo.materialTextStyleId,
        textStyle: styles,
      });
    },
    // 选中头像
    selectPortrait(portrait) {
      const data = genMaterialData(portrait);
      this.updateBannerData(data);
    },
    // 更新素材
    updateMaterials() {
      const background = randomItemExcept(this.bannerBackgrounds, this.bannerData.backgroundId);
      const element = randomItemExcept(this.bannerElements, this.bannerData.elementId);
      const data = genMaterialData(element, background);
      this.updateBannerData(data);
    },
    // 获取头像列表
    async getPortraits(params) {
      this.portraitMap = await getPortraits(params);
    },
    isPortraitMaterialType,
    isActiveBannerType(type) {
      if (type === 3) return this.isPortraitMaterialType(this.bannerData.elementTypeId);
      return Number(this.bannerData.elementTypeId) === type;
    },
    // 重新获取素材
    regainMaterials({ id }) {
      this.updateBannerData({ tagId: id });
      Promise.all([getBackgrounds(id, 1), getElements(id, 1)]).then(([bgs, eles]) => {
        this.setBannerMaterials({
          backgrounds: bgs,
          elements: eles,
        });
        this.updateMaterials();
      });
      this.selectIconVisible = 1;
    },
    // 更新label样式
    changeLabelStyle(style, params) {
      this.updateBannerData({
        data: style,
        params,
      });
    },
    // 切换头像和普通素材
    async switchType(type, pickedElement) {
      let data = null;
      // 普通素材
      if (type === 2) {
        const element = pickedElement || freshItemOfArr(this.bannerElements, this.bannerData.elementId);
        data = genMaterialData(element);
      } else {
        // 头像的bannerData的bannerInfo需要重新设置
        data = genMaterialData(this.portraitMap.list[0]);
      }
      this.updateBannerData(data);
    },
    navigateBack() {
      this.$store.commit("banner/clearCacheInfo");
      this.activeTab = 1;
    },
    toDesign() {
      this.activeTab = 1;
      // this.$store.commit('banner/clearCacheInfo');
    },
    async toDesignDetail(schemeId) {
      this.activeTab = 1;
      this.schemeId = schemeId;
      const data = await getDesignDetail(schemeId);
      this.structBannerDataList(data);
      Promise.all([getBackgrounds(this.bannerData.tagId, 1), getElements(this.bannerData.tagId, 1)]).then(
        ([bgs, eles]) => {
          this.setBannerMaterials({
            backgrounds: bgs,
            elements: eles,
          });
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.page-tabs {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 50px;
  width: 800px;
  margin: 0 calc(50vw - 400px - 200px);
  li {
    cursor: pointer;
    line-height: 50px;
    width: 100px;
    text-align: center;
    color: #999;
    &.active {
      color: #3f69f9;
    }
  }
}
.title {
  margin-top: 20px;
  font-size: 16px;
  color: #727375;
}
.build {
  height: 100%;
  position: relative;
  margin-left: calc((50vw - 400px - 200px));
  width: 800px;
  height: calc(100% - 60px);
  overflow: hidden;
  .tabs {
    margin: 15px 0 10px;
    width: 400px;
    height: 52px;
    line-height: 52px;
    border-radius: 6px;
    background: #f1f2f5;
    box-shadow:
      -1px -1px 1px 0px #eceef5 inset,
      0px 1px 0px 0px #fff inset,
      0px 8px 10px 0px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    .item {
      display: inline-block;
      width: 50%;
      color: #666;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      &.on {
        background: #3f69f9;
        color: #fff;
      }
    }
  }
  .show-banner {
    position: relative;
    margin-top: 10px;
    // display: flex;
    // justify-content: start;
    // align-items: end;
  }
  .real-banner {
    position: absolute;
    top: -800px;
  }
}
.msg {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0);
  color: #b6b8bb;
}

.loading {
  &::after {
    position: fixed;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
    background: rgba(0, 0, 0, 0.5);
  }

  .text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 10px 20px;
    border-radius: 6px;
    z-index: 9999;
    background: #fff;
  }
}
</style>
